import Slider from "react-slick";
import "./index.scss";
import { useGetReferralBrands } from "./utils/useGetReferralBrands";
import { CardBrand } from "components/UI/molecules";
import { CampaignSliderArrow } from "components/UI/atoms";
import { useGetSliderResponsiveOptions } from "./utils/useGetSliderResponsiveOptions";

export const ReferralBrands = () => {
  const { isLoading, brands } = useGetReferralBrands();
  const { slidesToScroll, slidesToShow } = useGetSliderResponsiveOptions();
  const sliderSettings = {
    dots: false,
    infinite: false,
    autoplay: false,
    arrows: true,
    slidesToScroll,
    slidesToShow,
    nextArrow: <CampaignSliderArrow />,
    prevArrow: <CampaignSliderArrow />
  };

  return (
    <section
      className="more-ways-brands-container"
      data-testid="more-ways-brands"
    >
      <h2 className="brands-title">More Ways To Earn</h2>
      <p className="brands-description">
        Don’t forget! You can also earn GCX Cash when you buy GCX Cash gift
        cards for yourself or send them as a gift.
      </p>
      {!isLoading && brands && (
        <div className="slider-brands-container">
          <Slider {...sliderSettings}>
            {brands.map((item) => (
              <div key={item.brandName} data-testid="slider-item">
                <CardBrand {...item} customClassName="carousel-brand" />
              </div>
            ))}
          </Slider>
        </div>
      )}
    </section>
  );
};
